import { REDUX_STORE } from '@funnels/constants';
import {
  Asset,
  ClearAssetErrorAction,
  CreateAssetAction,
  CreateAssetFailAction,
  CreateAssetSuccessAction,
  DeleteAssetAction,
  DeleteAssetFailAction,
  DeleteAssetSuccessAction,
  FetchAssetsAction,
  FetchAssetsFailAction,
  FetchAssetsSuccessAction,
  ServerAssetFetch,
  SetAssetErrorAction,
  UpdateAssetAbortAction,
  UpdateAssetAction,
  UpdateAssetFailAction,
  UpdateAssetSuccessAction,
  UpsertAssetsAction,
  UpsertAssetsFailAction,
  UpsertAssetsSuccessAction,
} from '@funnels/types';

export function clearAssetError(): ClearAssetErrorAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.CLEAR_ASSET_ERROR };
}

export function createAsset(applicationId: string, asset: Asset): CreateAssetAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.CREATE_ASSET, applicationId, asset };
}

export function createAssetFail(clientId: string): CreateAssetFailAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.CREATE_ASSET_FAIL, clientId };
}

export function createAssetSuccess(clientId: string, id: string): CreateAssetSuccessAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.CREATE_ASSET_SUCCESS, clientId, id };
}

export function deleteAsset(applicationId: string, clientId: string, id?: string): DeleteAssetAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.DELETE_ASSET, applicationId, clientId, id };
}

export function deleteAssetFail(clientId: string): DeleteAssetFailAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.DELETE_ASSET_FAIL, clientId };
}

export function deleteAssetSuccess(): DeleteAssetSuccessAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.DELETE_ASSET_SUCCESS };
}

export function fetchAssets(applicationId: string): FetchAssetsAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.FETCH_ASSETS, applicationId };
}

export function fetchAssetsFail(): FetchAssetsFailAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.FETCH_ASSETS_FAIL };
}

export function fetchAssetsSuccess(assets: ServerAssetFetch[]): FetchAssetsSuccessAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.FETCH_ASSETS_SUCCESS, assets };
}

export function setAssetError(message: string = 'Unknown error'): SetAssetErrorAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.SET_ASSET_ERROR, message };
}

export function updateAsset(applicationId: string, asset: Asset): UpdateAssetAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPDATE_ASSET, applicationId, asset };
}

export function updateAssetFail(clientId: string): UpdateAssetFailAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPDATE_ASSET_FAIL, clientId };
}

export function updateAssetAbort(): UpdateAssetAbortAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPDATE_ASSET_ABORT };
}

export function updateAssetSuccess(): UpdateAssetSuccessAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPDATE_ASSET_SUCCESS };
}

export function upsertAssets(applicationId: string, assets: Asset[]): UpsertAssetsAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPSERT_ASSETS, applicationId, assets };
}

export function upsertAssetsFail(): UpsertAssetsFailAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPSERT_ASSETS_FAIL };
}

export function upsertAssetsSuccess(): UpsertAssetsSuccessAction {
  return { type: REDUX_STORE.ASSETS.ACTION_TYPES.UPSERT_ASSETS_SUCCESS };
}
